import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import {Helmet} from "react-helmet";
import Home from './pages/Home';
import DetallesBlog from './pages/DetallesBlog';
import DetallesGuid from './pages/DetalleGuid';
import DetallesGuid2 from './pages/DetalleGuid2';
import NuevoLibro from './pages/NuevoLibro';
import IdeasLibertad from './pages/SecIdeas';
import SobreMi from './pages/SobreMi';
import LibroBl from './pages/LibroBl';
import BusquedaGeneral from './pages/Busqueda';
import ActividadRBS from './pages/ActividadRBS';
import ActividadAlgorithia from './pages/ActvAlgorithia';
// import Libertad from './pages/Libertad';
import IdeaCorta from './pages/IdeaCorta';
import SecBibliote from './pages/SecBibliote';
import SecBibliotecaTodos from './pages/SecBibliotecaTodos';
import IdeaCortaTodos from './pages/ideaCortaTodos';
import Comen from './pages/Comentario';
import IdeasLibertadTodas from './pages/IdeasLibTodas';
import LibroAzul from './pages/LibroAzul';
import Privacy from './pages/Privacy';
import TestForm from './pages/Testform';
import Tesis from './pages/Tesis';
import LibroBitcoin from './pages/LibroBitcoin';


function App() {
  return (
    <Router>
      <Helmet>
            <title>Sitio oficial de Ricardo Salinas</title>
            {/*<meta name="description" content="En 2008 comencé a compartir mis ideas y puntos de vista sobre diversos temas." />
            <meta property="og:title" content="Sitio oficial de Ricardo Salinas" />
            <meta property="og:description" content="En 2008 comencé a compartir mis ideas y puntos de vista sobre diversos temas." />
            <meta property="og:type" content="website" />
            <meta property="og:image" content="https://www.ricardosalinas.com/static/media/fotoRS.f8a63f65b159e735a517.png" />
            <meta property="og:url" content="https://www.ricardosalinas.com/" /> */}
        </Helmet>
      <Routes>

        {/* Con idioma en ruta */}

        <Route path="/:lang/" element={<Home />} />
        <Route path="/:lang/Ideas-en-Corto" element={<IdeaCorta />} />
        <Route path="/:lang/Ideas-en-Corto/*" element={<IdeaCorta />} />
        <Route path="/:lang/Ideas-en-libertad" element={<IdeasLibertad />} />
        <Route path="/:lang/Sobre-mi" element={<SobreMi />} />
        <Route path="/:lang/LibroLibertad" element={<LibroBl />} />
        <Route path="/:lang/LibroSociedades" element={<NuevoLibro />} />
        <Route path="/:lang/libronegocios" element={<LibroAzul />} />
        <Route path="/:lang/libroBitcoin" element={<LibroBitcoin />} />
        <Route path="/:lang/The-Bitcoin-Enlightenment" element={<LibroBitcoin />} />
        <Route path="/:lang/busqueda/:words"  element={<BusquedaGeneral/>} />
        <Route path="/:lang/Ideas-en-libertad-Todas" element={<IdeasLibertad />} />
        <Route path="/:lang/Ideas-en-corto-Todas" element={<IdeaCortaTodos />} />
        <Route path="/:lang/Biblioteca" element={<SecBibliote />} />
        <Route path="/:lang/Privacy" element={<Privacy />} />
        {/* Sin idioma en ruta */}

        <Route exact path="/" element={<Home />} />
        <Route path="/DetallesBlog" element={<DetallesBlog />} />
        <Route path="/blog/:friendly" element={<DetallesBlog />} />
        <Route path="/blog/es/:friendly" element={<DetallesGuid2 />} />
        <Route path="/blog/en/:friendly" element={<DetallesGuid2 />} />
        <Route path="/blog/blog.aspx" element={<DetallesGuid />} />
        <Route path="/busqueda/:words"  element={<BusquedaGeneral/>} />
        <Route path="/LibroSociedades" element={<NuevoLibro />} />
        <Route path="/Ideas-en-libertad" element={<IdeasLibertad />} />
        <Route path="/Sobre-mi" element={<SobreMi />} />
        <Route path="/1b108ba2-9767-4f9a-a01b-d55c1fac2d83" element={<ActividadRBS/>} />
        <Route path="/5bfd0e31-af85-4bb1-91c8-997d81fec963" element={<ActividadAlgorithia/>} />
        <Route path="/LibroLibertad" element={<LibroBl />} />
        <Route path="/libronegocios" element={<LibroAzul />} />
        <Route path="/libronegocios2" element={<LibroAzul />} />
        {/* <Route path="/LibroBitcoin" element={<LibroBitcoin />} /> */}
        {/* <Route path="/Libertad" element={<Libertad/>} /> */}
        {/* <Route path="/Libertad" element={<Libertad />} /> */}
        <Route path="/Ideas-en-Corto" element={<IdeaCorta />} />
        <Route path="/Biblioteca" element={<SecBibliote />} />
        <Route path="/Todos-los-libros" element={<SecBibliotecaTodos />} />

        <Route path="/tesis-doctoral" element={<Tesis />} />

        <Route path="/comentario" element={<Comen />} />
        <Route path="/IdeasLibertadTodas" element={ <IdeasLibertadTodas/>} />

        {/* <Route path="/Test-f-o" element={<TestForm />} />*/}
      </Routes>
    </Router>
  );

}

export default App;
